import { useEffect, useRef } from 'react';
import { useMediaContext } from '../MediaContext';
export const AudioTrack = ({ track }) => {
    const { activeAudioDevice: { id: activeSinkId } } = useMediaContext();
    const audioEl = useRef();
    useEffect(() => {
        audioEl.current = track.attach();
        document.body.appendChild(audioEl.current);
        return () => {
            track.detach().forEach((el) => {
                el.remove();
                // This addresses a Chrome issue where the number of WebMediaPlayers is limited.
                // See: https://github.com/twilio/twilio-video.js/issues/1528
                el.srcObject = null;
            });
        };
    }, [track]);
    useEffect(() => {
        var _a;
        if ((_a = audioEl.current) === null || _a === void 0 ? void 0 : _a.setSinkId)
            void audioEl.current.setSinkId(activeSinkId);
    }, [activeSinkId]);
    return null;
};
//# sourceMappingURL=AudioTrack.js.map